import { createFileRoute } from "@tanstack/react-router";
import { getWikiPage } from "@/features/community/records";
import { WikiPage, communityHead } from "@/features/community";
import {
  CommunityPageLoading,
  CommunityPageError,
} from "@/features/community/navigation";

export const Route = createFileRoute("/_site/$coworld/wiki/$")({
  loader: ({ location, abortController }) =>
    getWikiPage({
      data: { href: location.href },
      signal: abortController.signal,
    }),
  head: ({ loaderData }) => communityHead(loaderData?.metadata),
  pendingComponent: () => <CommunityPageLoading title="Wiki" />,
  errorComponent: ({ error, reset }) => (
    <CommunityPageError error={error} retry={reset} />
  ),
  component: () => <WikiPage data={Route.useLoaderData()} />,
});
